//------------- CALENDAR COMPONENT ---------

//calendário utilizado na página de Agenda

//importações
import React from "react";
import { useState, useEffect, useRef } from "react";
import "./styles.css";
import Requests from "../../services/requests";

//icons
import { FiClock } from "react-icons/fi";
import { BsCalendarWeekFill } from "react-icons/bs";
import { FiChevronLeft } from "react-icons/fi";
import { FiChevronRight } from "react-icons/fi";



function getMonthName(month) {
	switch (month) {
		case 0:
			return "Janeiro";
		case 1:
			return "Fevereiro";
		case 2:
			return "Março";
		case 3:
			return "Abril";
		case 4:
			return "Maio";
		case 5:
			return "Junho";
		case 6:
			return "Julho";
		case 7:
			return "Agosto";
		case 8:
			return "Setembro";
		case 9:
			return "Outubro";
		case 10:
			return "Novembro";
		case 11:
			return "Dezembro";
		default:
			return "";
	}
}

function getDayName(day) {
	switch (day) {
		case 0:
			return "Domingo";
		case 1:
			return "Segunda-feira";
		case 2:
			return "Terça-feira";
		case 3:
			return "Quarta-feira";
		case 4:
			return "Quinta-feira";
		case 5:
			return "Sexta-feira";
		case 6:
			return "Sábado";
		default:
			return "";
	}
}

function getBeginWeek(dt) {
	let dw = dt.getDay();
	let nDt = new Date(dt);
	nDt.setDate(nDt.getDate() - dw + 1);
	nDt.setHours(0, 0, 0, 0);
	return nDt;
}

function getAllWeek(dt) {
	let dayValue = 24 * 60 * 60 * 1000;

	let dth = new Date();
	dth.setHours(0, 0, 0, 0);

	let dt0 = new Date(dt);
	dt0.setHours(0, 0, 0, 0);

	return (
		<div className="days">
			<div className="days">
				{new Array(7).fill(false).map((el, i) => {
					let d = new Date(dt0.valueOf() + i * dayValue);

					let hoje = Math.abs(dth - d) < dayValue;

					return (
						<div
							key={"d-" + d.toDateString()}
							style={hoje ? { backgroundColor: "#cbe5e3" } : {}}
						>
							<p>{d.getDate()}</p>
							<p>{getDayName(d.getDay())}</p>
						</div>
					);
				})}
			</div>
		</div>
	);
}

function getWeekTasks(tasks = [], dt, dragOverIndex, setDragOverIndex, dropAgenda, changeAgenda, hoveredTask, setHoveredTask, cursorPosition, objjustificativas) {

	let dayValue = 24 * 60 * 60 * 1000;

	// tasks = [{ datahora_inicio: new Date(2022, 7, 25, 11, 0, 0, 0) }];

	let nt = tasks
		.filter((t) => {
			return Math.abs(new Date(t.datahora_inicio) - dt) < dayValue * 7;
		})
		.map((o) => {
			return { ...o, date_inicio: new Date(o.datahora_inicio) };
		});


	return (
		<div className="days">
			<div className="hours">
				{new Array(7).fill(false).map((v, i) => {
					return (
						<div key={i}>
							{Array(48)
								.fill(false)
								.map((_w, j) => {
									let ndt = new Date(dt);
									ndt.setDate(ndt.getDate() + i);
									ndt.setHours(0, 0, 0, 0);
									ndt.setMinutes(ndt.getMinutes() + j * 30);

									let find;
									let diffTime;
									let status;

									for (let k = 0; k < nt.length; k++) {
										if (nt[k].date_inicio.valueOf() === ndt.valueOf()) {
											find = nt[k];

											if (find.checkin) {
												let previstoInicio = new Date(find.datahora_inicio);
												let previstoFim = new Date(find.datahora_fim)
												let checkin = new Date(find.checkin);
												let diffTimeInicio = checkin - previstoInicio;
												let diffTimeFim = previstoFim - checkin;


												if (diffTimeInicio >= - 30 * 60000 && diffTimeFim >= - 30 * 60000) {
													status = 1;
												} else {
													status = 2;
												}
											} else if (
												find.justificativa != null &&
												!isNaN(find.justificativa)
											) {
												status = 3;
											} else {
												status = 0;
											}

											if (find.datahora_fim) {
												let diff =
													new Date(find.datahora_fim) -
													new Date(find.datahora_inicio);

												if (diff > 0) {
													diffTime = diff / 1000 / 60 / 30;
												}
											}
											break;
										}
									}

									return (
										<div
											key={j}
											id={j++}
											className={j % 2 === 0 ? "div-par" : "div-impar"}
											onDragOver={(e) => {
												e.preventDefault();
												setDragOverIndex({ i, j });
											}}
											onDragLeave={() => {
												setDragOverIndex();
											}}
											onDrop={(e) => {
												dropAgenda(ndt);
												setDragOverIndex();
											}}
											style={{
												position: "relative",

												...(dragOverIndex &&
													dragOverIndex.i === i &&
													dragOverIndex.j === j
													? { backgroundColor: "#00544d4b" }
													: {}),
											}}


										>
											{find && (
												<button
													key={1}
													style={{
														width: "100%",
														flexDirection: "column",
														position: "absolute",
														display: "flex",
														justifyContent: "center",
														alignItems: "center",
														color: "white",
														fontWeight: "bold",
														textAlign: "center",
														backgroundColor: find.cor,
														zIndex: 2,
														fontFamily: "inherit",
														fontSize: 16,
														outline: 0,
														border: 0,
														cursor: "pointer",
														overflow: "hidden",

														height:
															diffTime != null && !isNaN(diffTime)
																? `${diffTime * 102}%`
																: "100%",
													}}
													onClick={() => {
														changeAgenda(find);
													}}
													onMouseEnter={() => setHoveredTask(find)}
													onMouseLeave={() => setHoveredTask(null)}

												>
													<div
														style={{
															position: "absolute",
															right: 3,
															top: 3,
															display: "inline-block",
															height: 10,
															aspectRatio: 1,
															border: "2px solid black",
															borderRadius: 10000,
															backgroundColor:
																status === 0
																	? "red"
																	: status === 1
																		? "lime"
																		: status === 2
																			? "yellow"
																			: status === 3
																				? "gray"
																				: "black",
														}}
													></div>

													<div>
														<span style={{}}>{find.rota}</span>
														<span
															style={{
																color: "#cccccc",
																fontSize: 14,
															}}
														>
															{" - "}
															{find.descricao}
														</span>
													</div>
												</button>
											)}
										</div>
									);
								})}
						</div>
					);
				})}
				{hoveredTask && objjustificativas.map((obj) => {
					if (obj.id === hoveredTask.justificativa) {
						return (
							<div className="calendar-pop-up"
								style={{
									display: hoveredTask ? 'block' : 'none',
									position: 'absolute',
									top: 500, // Use as coordenadas da tarefa
									left: 1100, // Use as coordenadas da tarefa
									width: '200px',
									padding: '10px',
									background: 'white',
									boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.3)',
									zIndex: '999'
								}}>
								<h3>Justificativa:</h3>
								<p><strong>Tipo:</strong> {obj.tipo} <br /> <strong>Motivo:</strong> {obj.motivo} <br /> <strong>Data:</strong> {obj.data.replace(/^(\d{4}-\d{2}-\d{2}).*$/, "$1")}</p>
							</div>
						)
					}
				})}
			</div>
		</div>
	);
}

const Calendario = ({ token, agenda, dropAgenda, changeAgenda }) => {
	const [loading, setLoading] = useState(false); //animação de loading das rotas na pag Agenda
	//states do calendario
	const [dataAtual, setDataAtual] = useState(getBeginWeek(new Date()));
	const [dragOverIndex, setDragOverIndex] = useState();
	const [isScrolledToCenter, setIsScrolledToCenter] = useState(false);
	const [hoveredTask, setHoveredTask] = useState(null);
	const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });
	const [objjustificativas, setObjJustificativas] = useState([]);
	const [resultjustificativas, setResultjustificativas] = useState([])

	const tokenUser = JSON.parse(sessionStorage.getItem("token"))
	let config = { headers: { "x-access-token": tokenUser } };

	let arrayObjsJustificativas = []
	useEffect(() => {
		if (agenda) {
			agenda.map(async (obj) => {
				if (obj.justificativa != null && obj.justificativa != undefined) {

					// arrayObjsJustificativas.push(obj);
					// setObjJustificativas(arrayObjsJustificativas)
					const result = await Requests.getAllJustificativasById(obj.justificativa, config)
					// console.log("obj", result)
					if (result && result.length > 0) {

						let objeto = {
							id: obj.justificativa,
							tipo: result[0].tipo,
							motivo: result[0].motivo,
							data: result[0].datahora_fim,
						}

						arrayObjsJustificativas.push(objeto);
						setObjJustificativas(arrayObjsJustificativas)
					} else {
						console.log("Resultado vazio")
					}
				}
			});
		}

	}, [agenda])

	// setObjJustificativas(arrayObjsJustificativas)



	// let resultId = [];
	// const getJustificativa = async (justId)  => {
	// 	const result = await Requests.getAllJustificativasById(justId, config)
	// 	if (result && result.length > 0) {

	// 		let obj = {
	// 			id: justId,
	// 			tipo: result[0].tipo,
	// 			motivo: result[0].motivo,
	// 			data: result[0].datahora_fim,
	// 		}
	// 		resultId.push(obj);
	// 		// return result;
	// 	} else {
	// 		console.log("Resultado vazio")
	// 	}
	// }

	// objjustificativas.map((obj) => {
	// 	getJustificativa(obj.justificativa)
	// 	console.log("resultId", resultId)
	// })


	const calendarRef = useRef(null);

	useEffect(() => {
		if (!isScrolledToCenter && calendarRef.current) {
			const calendarElement = calendarRef.current;
			const scrollTop = calendarElement.scrollTop;
			const scrollHeight = calendarElement.scrollHeight;
			const clientHeight = calendarElement.clientHeight;

			// Verifica se o scroll está perto do centro
			const isNearCenter = Math.abs(scrollTop - (scrollHeight / 2 - clientHeight / 2)) <= 1;

			if (!isNearCenter) {
				// Rola o elemento para o centro
				calendarElement.scrollTo({
					top: scrollHeight / 2 - clientHeight / 2,
					behavior: "smooth"
				});
			}

			setIsScrolledToCenter(true);
		}
	}, [isScrolledToCenter]);

	//view do calendario
	return (
		<div className="calendar-component" ref={calendarRef} style={{ height: '1284px', overflowY: 'scroll' }}>
			<div id="calendar-header">
				{/* botão calendário, a ideia aqui será abrir um calendario do 
                ano vigente, onde o usuário irá selecionar o mês */}
				<BsCalendarWeekFill></BsCalendarWeekFill>
				{/* botão que anda uma semana para trás */}
				<FiChevronLeft
					className="page-btn"
					onClick={() => {
						setLoading(true);
						setTimeout(() => {
							setDataAtual((dt) => {
								let nDt = new Date(dt);
								nDt.setDate(nDt.getDate() - 7);
								return nDt;
							});
							// setPage(page - 1);
							setLoading(false);
						}, 200);
					}}
				/>
				{/* botão que anda uma semana para frente */}
				<FiChevronRight
					className="page-btn"
					onClick={() => {
						setLoading(true);
						setTimeout(() => {
							setDataAtual((dt) => {
								let nDt = new Date(dt);
								nDt.setDate(nDt.getDate() + 7);
								return nDt;
							});
							// setPage(page + 1);
							setLoading(false);
						}, 200);
					}}
				/>
				<p>{getMonthName(dataAtual.getMonth()) + " de " + dataAtual.getFullYear()}</p>
			</div>
			{/* row header do calendario, mostra os dias da semana */}
			<div id="calendar-days">{getAllWeek(dataAtual)}</div>
			{/* rcoluna de horarios do calendario, alinha as horas aos slots de tarefa */}
			<div id="calendar-hours">
				<div className="margem"></div>
				<div>
					<FiClock></FiClock>
				</div>
				{/* coluna que mostra as horas do dia de trabalho  */}
				{Array(24)
					.fill("")
					.map((h, i) => {
						// const hour = (i + 8) % 24;
						// if (hour < 0) {
						// return null;
						// }
						return (
							<div
								key={"hours-" + i + "-" + h}
								className={i % 2 === 0 ? "div-par" : "div-impar"}
							>
								<p>{i + ":00"}</p>
							</div>
						);
					})}
			</div>
			{/* rows de horarios do calendario, mostra cada slot onde será atribuida uma tarefa */}
			<div
				id="calendar-slots"
				className="calendar-slots"
				onMouseMove={(e) => { setCursorPosition({ x: e.clientX, y: e.clientY }) }}
			>
				{getWeekTasks(
					agenda,
					dataAtual,
					dragOverIndex,
					setDragOverIndex,
					dropAgenda,
					changeAgenda,
					hoveredTask,
					setHoveredTask, // Passa o estado hoveredTask como propriedade
					cursorPosition,
					objjustificativas,
				)}
			</div>
		</div>
	);
};

export default Calendario;
